export default __webpack_public_path__ + "static/media/phones.03df413b.webp";